import { Divider } from '@mui/material'
import React, { useContext } from 'react'
import { PrioridadesContext } from '../../pages/catalogos/PrioridadesPage'
import { DepartamentoComponent } from './DepartamentoComponent'



export const TablaDepartamentos = ({departamentos}) => {
  //const {modalAgregaPrioridad, setModalAgregaPrioridad} = useContext(PrioridadesContext);
  console.log('departamentos recibidas en tabla', departamentos)

  return (
    <div
        style={{
            display:'column',
            maxWidth:1024,
            marginTop:20,
            maxHeight:'60%',
            overflowY:'auto'
        }}
    >
      <div
        style={{
          display:'flex',
          flexDirection:'row'
        }}
      >
        <div
          style={{
            fontSize:14,
            fontWeight:'bold'
          }}
        >
          Departamentos
        </div>
      </div>
      <Divider />
      {
        departamentos?.map(departamento => (
          <DepartamentoComponent departamento={departamento} />
        ))
      }
    </div>
  )
}
